import { h, Component } from 'preact'
import ReactTooltip from 'react-tooltip'
import PoliticianSummary from './PoliticianSummary'
import PoliticianChartTabs from './PoliticianChartTabs'
import PoliticianVotes from './PoliticianVotes'
import { colors, transition } from '../../constants'
import { Block, withDimensions, MailBlock } from '../layout'
import Chevron from '../Chevron'
import Page from '../Page'
import Header from '../layout/Header'
import { Explainer } from '../PoliticianList/PoliticianListIntro'

class PoliticianPage extends Component {
  constructor(props) {
    super(props)
    this.state = { visibleRest: 0 } // 0 = all
  }
  getVotes(rest) {
    if (rest === 0) {
      return Array(9)
        .fill(0)
        .map((e, i) => this.getVotes(i + 1))
        .reduce((a, b) => a.concat(b))
    }
    const o = this.props[`rest${rest}`]
    return o
      ? o.votes.map((v, i) => ({
          ...v,
          restName: o.restName,
          i: `${rest}.${i}`,
        }))
      : []
  }
  render() {
    return (
      <div style={{ minWidth: 512 }}>
        <Header hasTooltip />
        <Block style={{ padding: '40px 0 0 0' }}>
          <PoliticianSummary
            {...this.props}
            party={this.props.parties[this.props.person.party] || {}}
          />
          <PoliticianChartTabs
            {...this.props}
            visibleRest={this.state.visibleRest}
            setVisibleRest={n => this.setState({ visibleRest: n })}
          />
        </Block>
        <Block>
          <Explainer />
        </Block>
        <MailBlock gaId="detail-politika-top" />
        <div
          style={{
            backgroundColor: colors.grey,
            paddingBottom: 40,
            transition,
          }}
        >
          <Chevron color={colors.yellow} />
          <Block>
            <PoliticianVotes
              small={this.props.small}
              votes={this.getVotes(this.state.visibleRest)}
              person={this.props.person}
            />
          </Block>
        </div>
        <ReactTooltip multiline effect="solid" class="tooltip" />
      </div>
    )
  }
}

const PoliticianPageWithDimensions = withDimensions(props => {
  const { width } = props.dimensions
  return (
    <PoliticianPage {...props} small={width < 930} dimensions={undefined} />
  )
})

export default props => (
  <Page hostname={props.hostname}>
    <PoliticianPageWithDimensions {...props} />
  </Page>
)



// WEBPACK FOOTER //
// ./components/PoliticianDetail/PoliticianPage.js